// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J7Tj","label":"styles_label__xoCfQ"};